/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {BulkUpdateAdminRoleRequest} from '../models/BulkUpdateAdminRoleRequest';
import type {BulkUpdateAdminRoleResult} from '../models/BulkUpdateAdminRoleResult';
import type {Error} from '../models/Error';

export interface BulkUpdateAdminRole$Request {
    bulkUpdateAdminRoleRequest: BulkUpdateAdminRoleRequest;
    reason?: string;
}

export interface BulkUpdateAdminRole$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkUpdateAdminRoleRequest = createAction<PayloadData<void, BulkUpdateAdminRole$Request>>('BULK_UPDATE_ADMIN_ROLE__BULK_UPDATE_ADMIN_ROLE__REQUEST');
export const bulkUpdateAdminRoleSuccess = createAction<PayloadData<string, BulkUpdateAdminRole$Request>>('BULK_UPDATE_ADMIN_ROLE__BULK_UPDATE_ADMIN_ROLE__SUCCESS');
export const bulkUpdateAdminRoleFailure = createAction<PayloadData<Error, BulkUpdateAdminRole$Request, true>>('BULK_UPDATE_ADMIN_ROLE__BULK_UPDATE_ADMIN_ROLE__FAILURE');

export const bulkUpdateAdminRoleActions = [
    bulkUpdateAdminRoleRequest,
    bulkUpdateAdminRoleSuccess,
    bulkUpdateAdminRoleFailure
] as const;

/**
 * @param {BulkUpdateAdminRoleRequest} meta.bulkUpdateAdminRoleRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkUpdateAdminRole = (meta: BulkUpdateAdminRole$Request, config?: BulkUpdateAdminRole$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkUpdateAdminRoleActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/bulk-actions/users/update-admin-role`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.bulkUpdateAdminRoleRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAdminRoleUpdateProgress$Request {
    id: string;
}

export interface GetAdminRoleUpdateProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdminRoleUpdateProgressRequest = createAction<PayloadData<void, GetAdminRoleUpdateProgress$Request>>('BULK_UPDATE_ADMIN_ROLE__GET_ADMIN_ROLE_UPDATE_PROGRESS__REQUEST');
export const getAdminRoleUpdateProgressSuccess = createAction<PayloadData<BulkProgress, GetAdminRoleUpdateProgress$Request>>('BULK_UPDATE_ADMIN_ROLE__GET_ADMIN_ROLE_UPDATE_PROGRESS__SUCCESS');
export const getAdminRoleUpdateProgressFailure = createAction<PayloadData<Error, GetAdminRoleUpdateProgress$Request, true>>('BULK_UPDATE_ADMIN_ROLE__GET_ADMIN_ROLE_UPDATE_PROGRESS__FAILURE');

export const getAdminRoleUpdateProgressActions = [
    getAdminRoleUpdateProgressRequest,
    getAdminRoleUpdateProgressSuccess,
    getAdminRoleUpdateProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdminRoleUpdateProgress = (meta: GetAdminRoleUpdateProgress$Request, config?: GetAdminRoleUpdateProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAdminRoleUpdateProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/update-admin-role/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAdminRoleUpdateResult$Request {
    id: string;
}

export interface GetAdminRoleUpdateResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdminRoleUpdateResultRequest = createAction<PayloadData<void, GetAdminRoleUpdateResult$Request>>('BULK_UPDATE_ADMIN_ROLE__GET_ADMIN_ROLE_UPDATE_RESULT__REQUEST');
export const getAdminRoleUpdateResultSuccess = createAction<PayloadData<BulkUpdateAdminRoleResult, GetAdminRoleUpdateResult$Request>>('BULK_UPDATE_ADMIN_ROLE__GET_ADMIN_ROLE_UPDATE_RESULT__SUCCESS');
export const getAdminRoleUpdateResultFailure = createAction<PayloadData<Error, GetAdminRoleUpdateResult$Request, true>>('BULK_UPDATE_ADMIN_ROLE__GET_ADMIN_ROLE_UPDATE_RESULT__FAILURE');

export const getAdminRoleUpdateResultActions = [
    getAdminRoleUpdateResultRequest,
    getAdminRoleUpdateResultSuccess,
    getAdminRoleUpdateResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdminRoleUpdateResult = (meta: GetAdminRoleUpdateResult$Request, config?: GetAdminRoleUpdateResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAdminRoleUpdateResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/update-admin-role`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopAdminRoleUpdate$Request {
    id: string;
}

export interface StopAdminRoleUpdate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopAdminRoleUpdateRequest = createAction<PayloadData<void, StopAdminRoleUpdate$Request>>('BULK_UPDATE_ADMIN_ROLE__STOP_ADMIN_ROLE_UPDATE__REQUEST');
export const stopAdminRoleUpdateSuccess = createAction<PayloadData<void, StopAdminRoleUpdate$Request>>('BULK_UPDATE_ADMIN_ROLE__STOP_ADMIN_ROLE_UPDATE__SUCCESS');
export const stopAdminRoleUpdateFailure = createAction<PayloadData<Error, StopAdminRoleUpdate$Request, true>>('BULK_UPDATE_ADMIN_ROLE__STOP_ADMIN_ROLE_UPDATE__FAILURE');

export const stopAdminRoleUpdateActions = [
    stopAdminRoleUpdateRequest,
    stopAdminRoleUpdateSuccess,
    stopAdminRoleUpdateFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopAdminRoleUpdate = (meta: StopAdminRoleUpdate$Request, config?: StopAdminRoleUpdate$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopAdminRoleUpdateActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/update-admin-role`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

